import { PIPELINE_BUDGET_CATEGORY_STRUCTURES } from "./pipeline-demo-structure";

export const formatPipelineCurrency = (amount: number): string =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(amount);

export const formatPipelineCountUp = (
  amount: number,
  progress: number,
): number => Math.round(amount * Math.min(1, Math.max(0, progress)));

export const derivePipelineDemoBudgetGrandTotal = (): number =>
  PIPELINE_BUDGET_CATEGORY_STRUCTURES.reduce(
    (sum, category) => sum + category.estimate,
    0,
  );

export const getBudgetCategorySharePercent = (
  estimate: number,
  grandTotal: number,
): number => {
  if (grandTotal <= 0) return 0;
  return (estimate / grandTotal) * 100;
};

export const scoreToColumnIndex = (score: 1 | 2 | 3 | 4): number => 4 - score;
